export default class Camera {
  constructor(videoElement) {
    this.videoElement = videoElement
    this.stream = null
    this.hasFrontCamera = false
    this.cameraOn = false
    this.hasFlash = false
    this.facingMode = 'environment'
    this.flashOn = false
    this.photos = []
  }

  isVideoDevice(device) {
    return (
      device.kind === 'videoinput' &&
      (device.label.toLowerCase().includes('front') ||
        device.label.toLowerCase().includes('face') ||
        device.label.toLowerCase().includes('facing'))
    )
  }

  async detectCameras() {
    const devices = await navigator.mediaDevices.enumerateDevices()

    for (const device of devices) {
      if (this.isVideoDevice(device)) {
        this.hasFrontCamera = true
        break
      }
    }
  }

  async startCamera() {
    try {
      if (!this.cameraOn) {
        await this.detectCameras()
        this.cameraOn = true
      }

      let constraints = {
        video: {
          facingMode: this.facingMode,
          aspectRatio: { ideal: 16 / 9 }
        }
      }

      this.stream = await navigator.mediaDevices.getUserMedia(constraints)
      let tracks = this.stream.getTracks()

      this.hasFlash =
        tracks.length > 0 && Boolean(tracks[0].getCapabilities().torch)

      this.videoElement.srcObject = this.stream
    } catch (error) {
      console.error(`Error starting the camera: ${error}`)
    }
  }

  stopCamera() {
    if (!this.stream) return

    const tracks = this.stream.getTracks()
    tracks.forEach((track) => track.stop())
    this.videoElement.srcObject = null
  }

  async switchCamera() {
    this.facingMode = this.facingMode === 'user' ? 'environment' : 'user'

    if (this.videoElement.srcObject) {
      this.stopCamera()
      await this.startCamera()
    }
  }

  async toggleFlash() {
    if (!this.hasFlash) return

    const tracks = this.stream.getVideoTracks()

    if (tracks.length > 0) {
      const videoTrack = tracks[0]
      this.flashOn = !this.flashOn

      videoTrack.applyConstraints({
        advanced: [{ torch: this.flashOn }]
      })
    }
  }

  async takePhoto() {
    const canvas = document.createElement('canvas')
    canvas.width = this.videoElement.videoWidth
    canvas.height = this.videoElement.videoHeight
    const ctx = canvas.getContext('2d')
    ctx.drawImage(this.videoElement, 0, 0, canvas.width, canvas.height)

    const dataURL = canvas.toDataURL('image/jpeg')

    this.photos.push(dataURL)

    return dataURL
  }

  async fileToBase64(file) {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.readAsDataURL(file)
    })
  }

  async addPhotoFromGallery(file) {
    const base64img = await this.fileToBase64(file)
    this.photos.push(base64img)

    return base64img
  }
}
